import { useEffect, useState } from "react";
import { Table, Tag, Typography, Space, Button, message, Tooltip } from "antd";
import { useAuth } from "../../layout/auth";
import moment from "moment";
import "moment/locale/es-mx";
import axios from "axios";
import { Mail, MailOpen } from "lucide-react";

moment.locale("es-mx");

export default function Notifications(props) {
  const { id } = props;
  const auth = useAuth();
  const [allNotifications, setAllNotifications] = useState([]);

  const fetchNotifications = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/notificaciones/porVerificacion/${id}?u=${auth.UID}`);
      const data = await response.json();
      setAllNotifications(data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [id, auth.UID]);

  const handleMarkAs = (notificationId, status) => {
    const url = `${process.env.REACT_APP_API_URL}/notificaciones/${notificationId}/${status === 1 ? "leida" : "noLeida"}`;
    axios
      .put(url)
      .then(() => {
        message.success(`Notificación marcada como ${status === 1 ? "leída" : "no leída"}`);
        const updatedNotifications = allNotifications.map((n) => {
          if (n.NotificacionID === notificationId) {
            return { ...n, Estado: status };
          }
          return n;
        });
        setAllNotifications(updatedNotifications);
      })
      .catch(() => {
        message.error("Error al actualizar la notificación");
      });
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "Created_At",
      key: "Created_At",
      render: (text) => (
        <Space>
          <span>{moment(text, "YYYY-MM-DD").format("DD/MM/YYYY")}</span>
          <span>{moment(text, "YYYY-MM-DD").fromNow()}</span>
        </Space>
      ),
    },
    {
      title: "Mensaje",
      dataIndex: "Mensaje",
      key: "Mensaje",
    },
    {
      title: "Estado",
      dataIndex: "Estado",
      key: "Estado",
      render: (text) => {
        if (text === 0) {
          return <Tag color="green">Nueva</Tag>;
        } else if (text === 1) {
          return <span className="subtle-text">Leída</span>;
        }
      },
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (text, record) => (
        <Space size="middle">
          {record.Estado === 0 ? (
            <Tooltip title="Marcar como leída">
              <Button icon={<MailOpen size={16} color="#8c8c8c" />} onClick={() => handleMarkAs(record.NotificacionID, 1)} type="ghost" />
            </Tooltip>
          ) : (
            <Tooltip title="Marcar como no leída">
              <Button icon={<Mail size={16} color="#1890ff" />} onClick={() => handleMarkAs(record.NotificacionID, 0)} type="ghost" />
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const rowClassName = (record) => {
    return record.Estado === 0 ? "unread-notification-row" : "read-notification-row";
  };

  return (
    <div>
      <Typography.Title level={3} type="secondary">
        Actividad en esta verificación
      </Typography.Title>
      <Table
        columns={columns}
        dataSource={allNotifications}
        size="middle"
        style={{ width: "100%" }}
        rowKey="NotificacionID"
        rowClassName={rowClassName}
      />
    </div>
  );
}
